import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { UndoOutlined, PlayCircleOutlined } from '@ant-design/icons';

import { Button, Row, Col, Typography } from 'antd';
import {
  FormikTransfer,
  FormikDatePicker,
  FormikSelect,
  FormikButton
} from '../../Components/Formik';
import TransferOutTrackingReportActions from '../../Stores/TransferOutTrackingReport/Actions';

const { Text } = Typography;

class CriteriaForm extends React.PureComponent {
  constructor() {
    super();

    this.handleSearchDivision = this.handleSearchDivision.bind(this);
    this.handleSearchToLocation = this.handleSearchToLocation.bind(this);
    this.handleSearchTransport = this.handleSearchTransport.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {}

  componentWillUnmount() {}

  handleSearchDivision(form, value) {
    const { fetchDivisionOptions } = this.props;

    fetchDivisionOptions(value);
  }

  handleSearchToLocation(form, value) {
    const { fetchToLocationOptions } = this.props;

    fetchToLocationOptions(value);
  }

  handleSearchTransport(form, value) {
    const { fetchTransportOptions } = this.props;

    fetchTransportOptions(value);
  }

  render() {
    const {
      intl,
      criteria,
      reportIsLoading,
      transferOutTracking,
      divisionOptions,
      divisionIsLoading,
      toLocationOptions,
      toLocationIsLoading,
      transportOptions,
      transportIsLoading
    } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={criteria}
        onSubmit={(values, formikBag) => {
          transferOutTracking(formikBag, values);
        }}
        validationSchema={Yup.object().shape({
          doc_date: Yup.date().min(
            new Date(1969, 12, 1),
            intl.formatMessage({ id: 'doc_date_is_required' })
          )
        })}
      >
        {({
          // values,
          // handleChange,
          // errors,
          // setFieldTouched,
          dirty,
          // touched,
          isSubmitting,
          // isValid,
          handleSubmit,
          handleReset
        }) => (
          <Form>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'start_date' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="start_date"
                  component={FormikDatePicker}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'end_date' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="end_date"
                  component={FormikDatePicker}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'division' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="division_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDivision}
                  notFoundContent={null}
                  loading={divisionIsLoading}
                  options={divisionOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'to_location' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="to_location_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchToLocation}
                  notFoundContent={null}
                  loading={toLocationIsLoading}
                  options={toLocationOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'transport' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="transport_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchTransport}
                  notFoundContent={null}
                  loading={transportIsLoading}
                  options={transportOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={24}>
                <Field
                  name="columns"
                  component={FormikTransfer}
                  intl={intl}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[0, 16]}>
              <Col span={24}>
                <Button
                  disabled={!dirty}
                  loading={isSubmitting || reportIsLoading}
                  onClick={handleReset}
                  icon={<UndoOutlined />}
                  type="primary"
                >
                  {intl.formatMessage({ id: 'reset' })}
                </Button>
                <Field
                  name="submit_action"
                  value="run_report"
                  component={FormikButton}
                  loading={isSubmitting || reportIsLoading}
                  onClick={handleSubmit}
                  label={intl.formatMessage({
                    id: 'run_report'
                  })}
                  icon={<PlayCircleOutlined />}
                  type="primary"
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    );
  }
}

CriteriaForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  // eslint-disable-next-line react/forbid-prop-types
  criteria: PropTypes.object,
  reportIsLoading: PropTypes.bool,
  transferOutTracking: PropTypes.func,
  fetchDivisionOptions: PropTypes.func,
  fetchToLocationOptions: PropTypes.func,
  fetchTransportOptions: PropTypes.func,

  divisionOptions: PropTypes.arrayOf(PropTypes.object),
  divisionIsLoading: PropTypes.bool,

  toLocationOptions: PropTypes.arrayOf(PropTypes.object),
  toLocationIsLoading: PropTypes.bool,

  transportOptions: PropTypes.arrayOf(PropTypes.object),
  transportIsLoading: PropTypes.bool
};

CriteriaForm.defaultProps = {
  intl: {},

  criteria: {},
  reportIsLoading: false,
  transferOutTracking() {},
  fetchDivisionOptions() {},
  fetchToLocationOptions() {},
  fetchTransportOptions() {},

  divisionOptions: [],
  divisionIsLoading: false,

  toLocationOptions: [],
  toLocationIsLoading: false,

  transportOptions: [],
  transportIsLoading: false
};

const mapStateToProps = state => ({
  timestamp: state.transferOutTrackingReport.timestamp,
  criteria: state.transferOutTrackingReport.criteria,

  reportIsLoading: state.transferOutTrackingReport.reportIsLoading,

  divisionOptions: state.transferOutTrackingReport.divisionOptions,
  divisionIsLoading: state.transferOutTrackingReport.divisionIsLoading,

  toLocationOptions: state.transferOutTrackingReport.toLocationOptions,
  toLocationIsLoading: state.transferOutTrackingReport.toLocationIsLoading,

  transportOptions: state.transferOutTrackingReport.transportOptions,
  transportIsLoading: state.transferOutTrackingReport.transportIsLoading
});

const mapDispatchToProps = dispatch => ({
  transferOutTracking: (formikBag, criteria) =>
    dispatch(
      TransferOutTrackingReportActions.transferOutTrackingReportTransferOutTracking(
        formikBag,
        criteria
      )
    ),

  fetchDivisionOptions: search =>
    dispatch(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchDivisionOptions(search)
    ),
  fetchToLocationOptions: search =>
    dispatch(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchToLocationOptions(search)
    ),
  fetchTransportOptions: search =>
    dispatch(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchTransportOptions(search)
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CriteriaForm));
